import React, { useEffect, useRef, useState } from "react";
import * as d3 from "d3";

const TrafficLightIntersection = ({ trafficLightStates }) => {
  const svgRef = useRef(null);
  const [currentTime, setCurrentTime] = useState(trafficLightStates[0]?.timestamp);

  useEffect(() => {
    if (!trafficLightStates || trafficLightStates.length === 0) return;

    const width = 400;
    const height = 400;
    const lightRadius = 10;
    const lightSpacing = 30;

    // Intersection rendering
    const svg = d3.select(svgRef.current)
      .attr("width", width)
      .attr("height", height)
      .style("background-color", "#f0f0f0");

    svg.selectAll("*").remove();

    const centerX = width / 2;
    const centerY = height / 2;
    const radius = 150;

    const currentLights = trafficLightStates.find(state => state.timestamp === currentTime)?.lights || [];

    currentLights.forEach(light => {
      const { state, orientation } = light;

      const angle = (orientation * Math.PI) / 180;
      const x = centerX + radius * Math.cos(angle);
      const y = centerY + radius * Math.sin(angle);

      svg.append("rect")
        .attr("x", x - lightSpacing / 2)
        .attr("y", y - lightSpacing * 1.5)
        .attr("width", lightSpacing)
        .attr("height", lightSpacing * 3)
        .attr("fill", "#333")
        .attr("rx", 5)
        .attr("ry", 5)
        .attr("transform", `rotate(${orientation}, ${x}, ${y})`);


      const colors = ["red", "yellow", "green"];
      colors.forEach((color, idx) => {
        svg.append("circle")
          .attr("cx", x)
          .attr("cy", y - lightSpacing * 1.5 + lightRadius + idx * lightSpacing)
          .attr("r", lightRadius)
          .attr("fill", state === color ? color : "#555")
          .attr("transform", `rotate(${orientation}, ${x}, ${y})`);
           });

      svg.append("text")
        .attr("x", x)
        .attr("y", y + lightSpacing * 2)
        .attr("text-anchor", "middle")
        .attr("font-size", "12px")
        .attr("fill", "#000")
        .text(`${orientation}°`);
    });
  }, [currentTime, trafficLightStates]);

  return (
    <div style={{ display: "flex" }}>

      {/* Timestamp List */}
      <div style={{ marginRight: "20px" }}>
        <h3>Available Timestamps</h3>
        <ul style={{ listStyleType: "none", padding: 0 }}>
          {trafficLightStates.map(state => (
            <li
              key={state.timestamp}
              style={{
                padding: "10px",
                margin: "5px 0",
                cursor: "pointer",
                backgroundColor: state.timestamp === currentTime ? "#ccc" : "#f9f9f9",
                border: "1px solid #ddd",
              }}
              onClick={() => setCurrentTime(state.timestamp)}
            >
              {new Date(state.timestamp).toLocaleTimeString()}
            </li>
          ))}
        </ul>
      </div>
      {/* Intersection */}
      <svg ref={svgRef}></svg>


    </div>
  );
};

export default TrafficLightIntersection;
